import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import { ComponentTabObject } from '../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import InputTableTopHeader from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import ITHeaderText from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { parseAddressToOneLine } from '../../../../../../../../../../utils/globals/address'
import { displayDate } from '../../../../../../../../../../utils/globals/date'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { getActiveCurrenciesDictionary } from '../../../../../../../../../../utils/reducers/getters'
import { AdjustmentDeliveryNoteModelType } from '@teinor/erp/types/company/order/adjustmentDeliveryNote'
import AdjustmentStepHeaderMainNoPermission from '../../../../header/AdjustmentStepHeaderMainNoPermission'

type AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & {}

const AdjustmentDeliveryNoteCreateNoPermissionStepITHeader: React.FC<AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderDefault} NewComponent={AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderNew} {...rest} />
}

const AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderDefault: React.FC<AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const tabs: ComponentTabObject = {
        'main': {
            component: AdjustmentStepHeaderMainNoPermission,
            text: t('dataDeliveryNote', 'Datos del albarán'),
            extraProps: { }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderNew: React.FC<AdjustmentDeliveryNoteCreateNoPermissionStepITHeaderProps> = ({ headerData, setCompleteData, ...rest }) => {
    const { t } = useTwinTranslation()
    const activeCurrencies = getActiveCurrenciesDictionary()

    const sections: FormRender<AdjustmentDeliveryNoteModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('customName', 'Nombre personalizado')} value={value} />
                },
                {
                    name: 'processed_date',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('dateAdjustmentOrder', 'Fecha de la regularización')} value={displayDate(new Date(value))} />
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('representative', 'Representante')} value={headerData?.RepresentativeEmployee?.fullname_short} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('assignedNumber', 'Nº asignado')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('adjustmentedBy', 'Comprado por')} value={headerData?.WorkingCenter.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WarehouseId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('warehouse', 'Almacen')} value={headerData?.Warehouse?.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterAddress', 'Dirección centro de trabajo')} value={parseAddressToOneLine(headerData?.BillingWorkingCenter)
                        } />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('currency', 'Moneda')} value={activeCurrencies?.[value]?.name} />,
                    hideSectionByDefault: true
                },
            ]
        }
    ]

    return (
        <InputTableTopHeader handleChange={async () => { }} sections={sections} headerData={headerData} getCompleteData={() => { }} />
    )
}

export default AdjustmentDeliveryNoteCreateNoPermissionStepITHeader